import { render, staticRenderFns } from "./CapitalSocial.container.vue?vue&type=template&id=acf4f25e&"
import script from "./CapitalSocial.container.vue?vue&type=script&lang=ts&"
export * from "./CapitalSocial.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports